module.exports = __webpack_public_path__ + "static/media/icon-eye-blue.02754215.svg";